export default (address, { multiline=false, fullState=false }={}) => {
    let display = '';
    if (address) {
        const separator = (multiline ? '<br />' : ' ');
        if (address.streetLines) {
            address.streetLines.forEach((streetLine) => {
                display = `${display}${streetLine}${separator}`;
            });
        }
        if (address.city) {
            display = `${display}${address.city}, `;
        }
        if (address.stateCode && !fullState) {
            display = `${display}${address.stateCode.code} `;
        }
        if (address.stateCode && fullState) {
            display = `${display}${address.stateCode.description} `;
        }
        if (address.postalCode) {
            display = `${display}${address.postalCode}`;
        }
    }
    return display;
};
